if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        // Reserve vertical space so the rest of the page doesn't shift down
        // when the lazy-fetched cards land. Inline display ignores min-height.
        this.style.display = 'block';
        this.style.minHeight = '400px';

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              // Strip motion-element wrappers entirely so NO Custom Element
              // constructor (and therefore no entrance animation) fires when
              // this markup is inserted post-paint. Each motion-element is
              // replaced with a plain <div> that preserves the original
              // classes; children move over unchanged. Cards / heading /
              // description render instantly at final scale.
              recommendations.querySelectorAll('motion-element').forEach((el) => {
                const div = el.ownerDocument.createElement('div');
                if (el.className) div.className = el.className;
                while (el.firstChild) div.appendChild(el.firstChild);
                el.parentNode.replaceChild(div, el);
              });

              // Strip the `loading` class from every .media-wrapper so the
              // image-lazy CSS doesn't start each <img> at opacity:0 and then
              // fade-in. With the recently-viewed-products.js stylesheet
              // override + this class strip, images render at full opacity
              // from the first paint.
              recommendations.querySelectorAll('.media-wrapper.loading').forEach((el) => {
                el.classList.remove('loading');
              });

              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (recommendations.classList.contains('complementary-products')) {
                this.closest('.product__block').remove();
              } else {
                this.closest('.shopify-section').remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            this.style.minHeight = '';
            console.error(e);
          });
      }
    }
  );
}
